<div id="container">

  <div class="w-1/5 h-48 flex flex-col items-center justify-between">

    <img
      id="csl-logo"
      [src]="ExternalLinksConstants.SURVIVORLINK_LOGO_URL"
      alt="Cancer SurvivorLink Logo"
      class="block"
    />

    <p-button size="large" label="Login to Clinic Portal" [style]="{'background-color': 'var(--clinic-portal-green)'}" (onClick)="onClickLogin()"></p-button>

  </div>
</div>
